import { apiServiceProxy } from 'v2/services/api-proxy';

import type { ApiServiceProxy } from 'v2/services/api-proxy';

class FIDCService {
  constructor(private apiService: ApiServiceProxy) {}

  public validateCustomerReject = (customer_id: number) => {
    return this.apiService.get(`fidc/validate-customer-reject/${customer_id}`);
  };
}

export const fidcService = new FIDCService(apiServiceProxy);
